import api from 'api';
import Ingredient from 'records/Ingredient';

export const CUSTOM_INGREDIENT_ASYNC_ACTION_START = 'CUSTOM_INGREDIENT_ASYNC_ACTION_START';
export const CUSTOM_INGREDIENT_ASYNC_ACTION_ERROR = 'CUSTOM_INGREDIENT_ASYNC_ACTION_ERROR';
export const CUSTOM_INGREDIENT_ASYNC_ACTION_SUCCESS = 'CUSTOM_INGREDIENT_ASYNC_ACTION_SUCCESS';
export const CUSTOM_INGREDIENT_RESET_STATE = 'CUSTOM_INGREDIENT_RESET_STATE';

function customIngredientAsyncActionStart() {
  return {
    type: CUSTOM_INGREDIENT_ASYNC_ACTION_START,
  };
}

function customIngredientAsyncActionError(error) {
  return {
    type: CUSTOM_INGREDIENT_ASYNC_ACTION_ERROR,
    error,
  };
}

function customIngredientAsyncActionSuccess() {
  return {
    type: CUSTOM_INGREDIENT_ASYNC_ACTION_SUCCESS,
  };
}

export function resetCustomIngredientState() {
  return {
    type: CUSTOM_INGREDIENT_RESET_STATE,
  };
}

export function createCustomIngredientAsync() {
  return (dispatch, getState) => {
    dispatch(customIngredientAsyncActionStart());
    return api.request(`ingredient/independent`, 'post')
    .then((data) => {
      dispatch(customIngredientAsyncActionSuccess());
      return new Ingredient(data);
    })
    .catch((error) => {
      dispatch(customIngredientAsyncActionError('Unable to create custom ingredient'));
      throw(error);
    });
  };
}

export function updateCustomIngredientAsync(ingredient) {
  return (dispatch, getState) => {
    dispatch(customIngredientAsyncActionStart());
    return api.request(`ingredient/independent`, 'put', ingredient)
    .then((data) => {
      dispatch(customIngredientAsyncActionSuccess());
      return new Ingredient(data);
    })
    .catch((error) => {
      dispatch(customIngredientAsyncActionError('Unable to update custom ingredient'));
      throw(error);
    });
  };
}

export function deleteCustomIngredientAsync(customIngredientId) {
  return (dispatch, getState) => {
    dispatch(customIngredientAsyncActionStart());
    return api.request(`ingredient/custom/${ customIngredientId }`, 'delete')
    .then((data) => {
      dispatch(customIngredientAsyncActionSuccess());
      return data;
    })
    .catch((error) => {
      dispatch(customIngredientAsyncActionError('Unable to delete custom ingredient'));
      throw(error);
    });
  };
}
